import { apiClient } from '../utils/apiClient';
import type {
  WizardConfig,
  TabConfig,
  QuestionConfig,
  CreateTabConfigRequest,
  UpdateTabConfigRequest,
  CreateQuestionRequest,
  UpdateQuestionRequest,
  CreateReportRequest,
  ReportDetail,
  ReportListItem,
} from '../types/api';

// ===== Configuración del Wizard =====
export const wizardConfigService = {
  // Obtener configuración completa
  async getConfig(): Promise<WizardConfig> {
    return apiClient.get<WizardConfig>('/reprove/config');
  },

  // ===== TABS =====
  async getAllTabs(): Promise<TabConfig[]> {
    return apiClient.get<TabConfig[]>('/admin/wizard/tabs');
  },

  async getTab(id: string): Promise<TabConfig> {
    return apiClient.get<TabConfig>(`/admin/wizard/tabs/${id}`);
  },

  async createTab(data: CreateTabConfigRequest): Promise<TabConfig> {
    return apiClient.post<TabConfig>('/admin/wizard/tabs', data);
  },

  async updateTab(
    id: string,
    data: UpdateTabConfigRequest
  ): Promise<TabConfig> {
    return apiClient.put<TabConfig>(`/admin/wizard/tabs/${id}`, data);
  },

  async deleteTab(id: string): Promise<void> {
    return apiClient.delete<void>(`/admin/wizard/tabs/${id}`);
  },

  async reorderTabs(tabIds: string[]): Promise<TabConfig[]> {
    return apiClient.put<TabConfig[]>('/admin/wizard/tabs/reorder', { tabIds });
  },

  // ===== QUESTIONS =====
  async getQuestions(tabId: string): Promise<QuestionConfig[]> {
    return apiClient.get<QuestionConfig[]>(
      `/admin/wizard/tabs/${tabId}/questions`
    );
  },

  async createQuestion(
    tabId: string,
    data: CreateQuestionRequest
  ): Promise<QuestionConfig> {
    return apiClient.post<QuestionConfig>(
      `/admin/wizard/tabs/${tabId}/questions`,
      data
    );
  },

  async updateQuestion(
    questionId: string,
    data: UpdateQuestionRequest
  ): Promise<QuestionConfig> {
    return apiClient.put<QuestionConfig>(
      `/admin/wizard/questions/${questionId}`,
      data
    );
  },

  async deleteQuestion(questionId: string): Promise<void> {
    return apiClient.delete<void>(`/admin/wizard/questions/${questionId}`);
  },

  async reorderQuestions(
    tabId: string,
    questionIds: string[]
  ): Promise<QuestionConfig[]> {
    return apiClient.put<QuestionConfig[]>(
      `/admin/wizard/tabs/${tabId}/questions/reorder`,
      {
        questionIds,
      }
    );
  },
};

// ===== Reportes =====
export const wizardReportsService = {
  async createReport(data: CreateReportRequest): Promise<ReportDetail> {
    return apiClient.post<ReportDetail>('/reprove/reports', data);
  },

  async getReports(): Promise<ReportListItem[]> {
    return apiClient.get<ReportListItem[]>('/reprove/reports');
  },

  async getReport(id: string): Promise<ReportDetail> {
    return apiClient.get<ReportDetail>(`/reprove/reports/${id}`);
  },
};

// ===== Export consolidado =====
export const wizardService = {
  config: wizardConfigService,
  reports: wizardReportsService,
};

export default wizardService;
